import { Controller } from "@hotwired/stimulus"

// The operations contract-expiry nudge (rendered already-open by the server for
// operations staff when a client's contract has lapsed). This controller only
// handles closing + persistence: any dismiss path (button, Escape, backdrop)
// records the client id in a day-scoped cookie the server reads to advance to
// the next-oldest lapsed client on the next page load. The cookie is namespaced
// by user id, so dismissal is strictly PER TEAM MEMBER: if Hunter dismisses a
// client, Ben still gets nagged until he dismisses (or deactivates) it himself.
// "Edit Client" is a plain link (the real resolution: deactivating drops the
// client from the query for good).
export default class extends Controller {
  static values = { clientId: Number, userId: Number }

  connect() {
    document.body.classList.add("overflow-hidden")
    this.onKeydown = (e) => { if (e.key === "Escape") this.dismiss() }
    document.addEventListener("keydown", this.onKeydown)
  }

  disconnect() {
    document.body.classList.remove("overflow-hidden")
    document.removeEventListener("keydown", this.onKeydown)
  }

  // Only when the backdrop itself is clicked, not the panel inside it.
  backdrop(event) {
    if (event.target === this.element) this.dismiss()
  }

  dismiss() {
    this.persist()
    this.element.remove()
    document.body.classList.remove("overflow-hidden")
  }

  // Record the dismissal in the cookie but leave the modal in place. The Edit
  // Client link fires this, then navigates, so the edit page it lands on does
  // not immediately re-cover its own form with this same client's reminder.
  persist() {
    const ids = (this.#read() || "").split(",").filter(Boolean)
    const id = String(this.clientIdValue)
    if (!ids.includes(id)) ids.push(id)
    document.cookie = `${this.#name()}=${ids.join(",")};path=/;max-age=86400;samesite=lax`
  }

  #name() {
    return `dismissed_contract_reminders_${this.userIdValue}`
  }

  #read() {
    const m = document.cookie.match(new RegExp("(?:^|; )" + this.#name() + "=([^;]*)"))
    return m ? decodeURIComponent(m[1]) : null
  }
}
